import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { Quotation } from "~/components/Quotation/Quotation"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const Sistema: React.FC = () => {
  const quotes = useApiContext("/quotes/list")
  const { t } = useTranslation()

  return (
    <div className={styles.Wrapper}>
      <div className="container">
        <Heading className={styles.Title} like="h2">
          <Raw html={t("stock.Quotations.Sistema.Title")} />
        </Heading>

        <div className={styles.Inner}>
          <div className={styles.List}>
            {quotes.length > 0 &&
              quotes
                .slice(0, 1)
                .map((quote, i) => <Quotation key={i} className={styles.Item} {...quote} />)}
          </div>

          <div>
            <Card className={styles.Note}>
              <Raw html={t("stock.Quotations.Sistema.Note")} />
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}
